import './styles/DetailPage.scss';

import { Grid, Paper } from '@mui/material';

import clsx from 'clsx';

interface Props {
  className?: string;
  sideInfo?: React.ReactNode;
  scrollable?: boolean;
  dialog?: boolean;
  children: React.ReactNode;
}

export default function DetailPage(props: Props) {
  const scrollVar = props.scrollable ?? false;
  const dialogVar = props.dialog ?? false;
  return (
    <Grid container className={clsx('detail-page', props.className)}>
      {props.sideInfo && (
        <Grid
          component={Paper}
          square
          item
          xs={12}
          md={dialogVar ? 4 : 3}
          className="detail-page__side-info"
        >
          {props.sideInfo}
        </Grid>
      )}
      <Grid
        component={Paper}
        square
        item
        xs={12}
        md
        className={clsx('detail-page__main-column', {
          'detail-page__main-column__scrollable': scrollVar
        })}
      >
        <Grid container>{props.children}</Grid>
      </Grid>
    </Grid>
  );
}
